export class WebhookV1StandardPayloadBackupJobRejected {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1StandardPayloadBackupJobRejectedTypeEnum",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "WebhookV1StandardPayloadBackupJobRejectedArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadBackupJobRejected.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1StandardPayloadBackupJobRejectedTypeEnum;
(function (WebhookV1StandardPayloadBackupJobRejectedTypeEnum) {
    WebhookV1StandardPayloadBackupJobRejectedTypeEnum["BackupJobRejected"] = "BACKUP_JOB_REJECTED";
})(WebhookV1StandardPayloadBackupJobRejectedTypeEnum || (WebhookV1StandardPayloadBackupJobRejectedTypeEnum = {}));
